
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M86 25.91H14a5.25 5.25 0 00-5.25 5.25v37.68A5.25 5.25 0 0014 74.09h72a5.25 5.25 0 005.25-5.25V31.16A5.25 5.25 0 0086 25.91zm2.79 42.93A2.79 2.79 0 0186 71.63H14a2.79 2.79 0 01-2.79-2.79V31.16A2.79 2.79 0 0114 28.37h72a2.79 2.79 0 012.79 2.79z"}}),_c('path',{attrs:{"d":"M17.15 62.78h25.71V37.07H17.15zm2.46-23.25H40.4v20.79H19.61zM49.39 37.14h31.05v2.46H49.39zM49.39 48.77h28.25v2.46H49.39zM49.39 60.4h31.05v2.46H49.39z"}})])
          )
        }
      }
    